export default __webpack_public_path__ + "079f346b42484e2ae7166b8e92019a41.png";